import { render } from "./UserRegistrationModal.vue?vue&type=template&id=71e83d2c&scoped=true"
import script from "./UserRegistrationModal.vue?vue&type=script&lang=js"
export * from "./UserRegistrationModal.vue?vue&type=script&lang=js"

import "./UserRegistrationModal.vue?vue&type=style&index=0&id=71e83d2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e83d2c"]])

export default __exports__